import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef } from "@angular/core";
import { delay, SharedService } from '../../shared';
import { ValueTypeEnum, CannabisQuestion, CannabisSection, CannabisOption, CannabisAnswer } from '../shared';


import { OrderByPipe, FilterByPipe, GroupByPipe } from '../../pipes'

@Component({
    selector: 'quest-options',
    templateUrl: "./quest-options.component.html",
    styleUrls: ["./quest-options.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class QuestOptionsComponent implements OnInit, OnChanges {
    @Input() section: CannabisSection;
    @Input() quest: CannabisQuestion;
    @Input() answer: CannabisAnswer;
    @Input() nOptions: CannabisOption[];
    @Input() dOptions: CannabisOption[];
    @Output() onSelectOption = new EventEmitter<any>();

    normalOptions: CannabisOption[] = [];
    dynamicOptions: CannabisOption[] = [];

    constructor(private sharedService: SharedService,
        private cd: ChangeDetectorRef,
        private filterPipe: FilterByPipe,
        private orderPipe: OrderByPipe,
        private groupPipe: GroupByPipe) {
    }

    ngOnInit(): void {
        this.loadFilteredOptions();
    }

    ngOnChanges(changes: any) {
        this.loadFilteredOptions();
    }

    hasFreeTextActve(value) {
        return this.quest.extraInput && value.indexOf(this.quest.extraInput) > -1;
    }

    hasStatiFreeTextActve(value) {
        return this.quest.freeTextInput && value.indexOf(this.quest.freeTextInput) > -1;
    }

    loadFilteredOptions() {
        const options = this.getFilteredOptions(this.quest, this.quest.options);
        const eIndex = options.findIndex(item => this.hasFreeTextActve(item.Label));
        if (eIndex > -1) {
            const option = options[eIndex];
            options.splice(eIndex, 1);
            options.push(option);
        }
        const sIndex = options.findIndex(item => this.hasStatiFreeTextActve(item.Label));
        if (sIndex > -1) {
            const option = options[sIndex];
            options.splice(sIndex, 1);
            options.push(option);
        }
        this.normalOptions = options;
        if (this.quest.hasDynamicOptions) {
            const dOptions = this.getFilteredOptions(this.quest, this.quest.dynamicOptions);
            const eIndex = dOptions.findIndex(item => this.hasFreeTextActve(item.Label));
            if (eIndex > -1) {
                const option = dOptions[eIndex];
                dOptions.splice(eIndex, 1);
                dOptions.push(option);
            }
            const sIndex = dOptions.findIndex(item => this.hasStatiFreeTextActve(item.Label));
            if (sIndex > -1) {
                const option = dOptions[sIndex];
                dOptions.splice(sIndex, 1);
                dOptions.push(option);
            }
            this.dynamicOptions = dOptions;
        } else {
            this.dynamicOptions = [];
        }
    }

    getFilteredOptions(quest: CannabisQuestion, options: CannabisOption[]) {
        if (quest.showFilter) {
            if (quest.fuzzyFilter) {
                options = this.sharedService.fuzzySearch(options, 'Label', quest.filterText);
            } else {
                options = this.filterPipe.transform(options, { Label: quest.filterText });
            }
        }
        if (quest.orderBy) {
            options = this.orderPipe.transform(options, quest.orderBy, false, true);
        }
        if (quest.groupBy) {
            const groupedOptions = this.groupPipe.transform(options, quest.groupBy);
            return this.orderPipe.transform(groupedOptions, "Label", false, true);
        } else {
            return options;
        }
    }

    activeSelectedOption(quest: CannabisQuestion, option: CannabisOption) {
        if (quest.valueType === ValueTypeEnum.OPTION) {
            return quest.answer.option.Label === option.Label;
        } else {
            return quest.answer.options.findIndex(a => a.Label === option.Label) > -1;
        }
    }

    selectOption(quest: CannabisQuestion, option: CannabisOption) {
        this.onSelectOption.emit(option);
    }

}
